import { type User } from "@vidario/domain";
import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { useVidarioClient } from "../client";
import { ApiError } from "../endpoints";
import { queryKeys } from "../queryKeys";

export interface UseMeOptions {
  /** Skip the request — e.g. while there's no auth session. Default `true`. */
  enabled?: boolean;
}

export function useMe(options: UseMeOptions = {}): UseQueryResult<User> {
  const { enabled = true } = options;
  const client = useVidarioClient();
  return useQuery({
    queryKey: queryKeys.me(),
    queryFn: () => client.getMe(),
    enabled,
    staleTime: 5 * 60 * 1000,
    retry: (count, err) => {
      if (err instanceof ApiError && err.status === 401) return false;
      return count < 2;
    },
  });
}
